import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { BeatLoader } from 'react-spinners'
import DataTable from 'react-data-table-component'
import { Doughnut } from 'react-chartjs-2'

// The row data is composed into your custom expandable component via the data prop
const ExpanableComponent = ({ data }) => {
  const columns = [
    { selector: 'firstName', name: 'First Name', sortable: true },
    { selector: 'lastName', name: 'Last Name', sortable: true },
    { selector: 'prescriberStatus', name: 'REMs Status', sortable: true },
    { selector: 'isActive', name: 'Athelas Status', sortable: true },
  ]
  return (
    <div>
      <DataTable
        title='REMS Patients'
        striped
        columns={columns}
        data={data.patients}
      />
    </div>
  )
}

class PrescribersView extends React.Component {
  static propTypes = {
    remsPrescribers: PropTypes.shape({}),
    isFetchingPrescriberSales: PropTypes.bool,
    getPrescriberSales: PropTypes.func
  }

  static defaultProps = {
    remsPrescribers: {},
    isFetchingPrescriberSales: true,
    getPrescriberSales: _.noop
  }

  componentDidMount = () => {
    const { getPrescriberSales } = this.props
    getPrescriberSales()
  }

  generateData = (remsPrescribers) => {
    return _.filter(_.map(remsPrescribers, (prescriber) => {
      const numActivePatients = _.size(_.filter(prescriber.patients, (patient) => patient.active))
      _.forEach(prescriber.patients, (p) => { p.isActive = p.active ? 'Yes' : 'No'})
      return {
        ...prescriber,
        firstName: _.capitalize(prescriber.firstName),
        lastName: _.capitalize(prescriber.lastName),
        totalRemsPatients: _.size(prescriber.patients),
        activeAthelasPatients: numActivePatients,
        percentAcquired: _.round(numActivePatients / _.size(prescriber.patients) * 100, 0)
      }
    }), (p) => p.totalRemsPatients > 0)
  }

  render () {
    const { remsPrescribers, isFetchingPrescriberSales } = this.props
    const columns = [
      { selector: 'firstName', name: 'First Name', sortable: true },
      { selector: 'lastName', name: 'Last Name', sortable: true },
      { selector: 'totalRemsPatients', name: 'Total REMs Patients', sortable: true },
      { selector: 'activeAthelasPatients', name: 'Active Athelas Patients', sortable: true },
      { selector: 'percentAcquired', name: '% of Patient Acquired', sortable: true }
    ]
    const data = this.generateData(remsPrescribers)
    const totalRemsPatients = _.sum(_.map(remsPrescribers, (p) => _.size(p.patients)))
    const totalAthelasPatients = _.sum(_.map(remsPrescribers, (p) => _.size(_.filter(p.patients, (pat) => pat.active))))
    const chartData = {
      datasets: [{
        data: [totalAthelasPatients, totalRemsPatients - totalAthelasPatients],
        backgroundColor: [
          '#ff6384',
          '#36a2eb'
        ],
      }],
      labels: [
        'Acquired Patients',
        'Remaining Patients'
      ]
    }
    return (
      <div>
        {
          isFetchingPrescriberSales ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
              <BeatLoader loading color={'#6f8eaa'} />
            </div>
          ) : (
            <div>
              <div style={{ padding: 20 }}>
                <h3>Prescriber Leads</h3>
                <h6>
                  {totalRemsPatients} on REMS
                </h6>
                <h6>
                  {totalAthelasPatients} on Athelas One
                </h6>
              </div>
              <div>
                <Doughnut data={chartData} height={60} />
              </div>
              <DataTable
                title='REMS Prescribers'
                columns={columns}
                data={data}
                expandableRows
                expandableRowsComponent={<ExpanableComponent />}
              />
            </div>
          )
        }
      </div>
    )
  }
}

export default PrescribersView



// WEBPACK FOOTER //
// ./src/routes/Clinic/components/PrescribersView.jsx